import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TextareaModule } from 'primeng/textarea';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { TextBoxCustomization } from './textbox-edit';

@Component({
  selector: 'lib-textbox-compiled',
  imports: [ReactiveFormsModule, TextareaModule, CdkTextareaAutosize],
  template: `
    @let widget = widgetService.widget();
    @let formControl = widgetService.formControl();
    @if (widget && formControl) {
      <div class="flex w-full flex-col gap-2">
        <label for="data" class="whitespace-normal text-justify">{{
          widget.customization.description
        }}</label>
        <div class="w-full">
          <textarea
            id="data"
            pTextarea
            [placeholder]="widget.customization.placeHolder"
            [formControl]="formControl"
            [rows]="10"
            cdkTextareaAutosize
            cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="20"
            class="w-full bg-white"
          ></textarea>
        </div>
      </div>
    }
  `,
  styleUrls: ['../style.css'],
  providers: [],
})
export class TextBoxCompiledComponent {
  protected widgetService = inject(
    CompilingWidgetService<TextBoxCustomization>,
  );

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
}
